export default "__VITE_ASSET__uhP$P7gl__";